<template>
	<div class="page-content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="page-title-box d-sm-flex align-items-center justify-content-between">
						<h4 class="mb-sm-0">Detail Pencairan Tutup Akun</h4>

						<div class="page-title-right">
							<ol class="breadcrumb m-0">
								<li class="breadcrumb-item">
									<router-link :to="{ name: 'close.account.liquidation' }">Pencairan Tutup Akun</router-link>
								</li>
								<li class="breadcrumb-item active">Detail</li>
							</ol>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-header">
							<h4 class="card-title">Informasi Form Tutup Akun</h4>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-6">
									<table class="table">
										<tbody>
											<tr>
												<td width="40%"><strong>Nama Lengkap</strong></td>
												<td>{{ data.name || '-' }}</td>
											</tr>
											<tr>
												<td><strong>NIK</strong></td>
												<td>{{ data.nik || '-' }}</td>
											</tr>
											<tr>
												<td><strong>Alamat</strong></td>
												<td>{{ data.address || '-' }}</td>
											</tr>
											<tr>
												<td><strong>Nomor Telepon</strong></td>
												<td>{{ data.phone_number || '-' }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="col-md-6">
									<table class="table">
										<tbody>
											<tr>
												<td width="40%"><strong>Nama Bank</strong></td>
												<td>{{ data.bank_name || '-' }}</td>
											</tr>
											<tr>
												<td><strong>Nomor Rekening</strong></td>
												<td>{{ data.bank_account_number || '-' }}</td>
											</tr>
											<tr>
												<td><strong>Nama Pemilik Rekening</strong></td>
												<td>{{ data.bank_account_name || '-' }}</td>
											</tr>
											<tr>
												<td><strong>Alasan Penutupan</strong></td>
												<td>{{ data.reason || '-' }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<!-- Foto KTP untuk Verifikasi -->
					<div class="card" v-if="data.ktp_image">
						<div class="card-header bg-warning-subtle">
							<h4 class="card-title mb-0">
								<i class="bx bx-id-card me-2"></i>Foto KTP untuk Verifikasi
							</h4>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12 text-center">
									<img 
										:src="getKtpImageUrl(data.ktp_image)" 
										alt="Foto KTP" 
										class="img-thumbnail" 
										style="max-width: 100%; max-height: 600px; cursor: pointer;"
										@click="openKtpPreview"
									/>
									<p class="text-muted mt-2 mb-0">
										<small>Klik gambar untuk melihat ukuran penuh</small>
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- Saldo Wallet -->
					<div class="card">
						<div class="card-header">
							<h4 class="card-title">Rincian Saldo Wallet</h4>
						</div>
						<div class="card-body">
							<table class="table">
								<thead>
									<tr>
										<th>Deskripsi</th>
										<th class="text-end">Jumlah</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="!walletData.has_wallet">
										<td colspan="2" class="text-center">Tidak ada saldo wallet</td>
									</tr>
									<template v-else>
										<tr>
											<td>Saldo Wallet</td>
											<td class="text-end">{{ formatCurrency(walletData.amount) }}</td>
										</tr>
										<tr>
											<td>Biaya Admin</td>
											<td class="text-end text-danger">- {{ formatCurrency(walletData.admin_fee) }}</td>
										</tr>
										<tr class="table-active">
											<td><strong>Total yang Ditransfer</strong></td>
											<td class="text-end"><strong>{{ formatCurrency(walletData.total_amount) }}</strong></td>
										</tr>
									</template>
								</tbody>
							</table>
						</div>
					</div>

					<!-- Daftar Saham -->
					<div class="card">
						<div class="card-header">
							<h4 class="card-title">Rincian Saham</h4>
						</div>
						<div class="card-body">
							<div class="table-responsive">
								<table class="table">
									<thead>
										<tr>
											<th>No Sertifikat</th>
											<th class="text-end">Jumlah Slot</th>
											<th class="text-end">Harga per Slot</th>
											<th class="text-end">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(share, index) in shareData" :key="index">
											<td>{{ share.share_number }}</td>
											<td class="text-end">{{ share.slot }}</td>
											<td class="text-end">{{ formatCurrency(share.price_per_slot) }}</td>
											<td class="text-end">{{ formatCurrency(share.total_amount) }}</td>
										</tr>
										<tr v-if="shareData.length === 0">
											<td colspan="4" class="text-center">Tidak ada saham</td>
										</tr>
										<tr class="table-active" v-if="shareData.length > 0">
											<td colspan="3" class="text-end"><strong>Total Nilai Saham</strong></td>
											<td class="text-end"><strong>{{ formatCurrency(totalShareAmount) }}</strong></td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<!-- Grand Total -->
					<div class="card">
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<h4 class="text-end">
										<strong>Grand Total Pencairan: {{ formatCurrency(grandTotal) }}</strong>
									</h4>
								</div>
							</div>
						</div>
					</div>

					<!-- Upload Bukti Transfer -->
					<div class="card" v-if="data.status === 'pending'">
						<div class="card-header">
							<h4 class="card-title">Upload Bukti Transfer</h4>
						</div>
						<div class="card-body">
							<div class="row">
							<div class="col-md-12">
								<div class="mb-3">
									<label class="form-label">Bukti Transfer <span class="text-danger">*</span></label>
									<input type="file" class="form-control" @change="filesChange($event)" accept="image/*" />
									<small class="text-muted">Format: JPG, PNG, JPEG. Max: 2MB</small>
								</div>
								<div class="mb-3" v-if="form.evidance_of_transfer_preview">
									<img :src="form.evidance_of_transfer_preview" alt="Preview" class="img-thumbnail" style="max-width: 300px;" />
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12 float-end text-end">
								<router-link :to="{ name: 'close.account.liquidation' }" class="btn btn-secondary">
									<i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
									Kembali
								</router-link>
								<button type="button" class="btn btn-primary ms-2" @click="processLiquidation()"
										:disabled="!form.evidance_of_transfer">
										<i class="bx bx-check font-size-16 align-middle me-2"></i>
										Proses Pencairan
									</button>
								</div>
							</div>
						</div>
					</div>

					<!-- Info jika sudah diproses -->
					<div class="card" v-else>
						<div class="card-body">
							<div class="alert alert-success" role="alert">
								<h5 class="alert-heading">
									<i class="bx bx-check-circle font-size-18 align-middle me-2"></i>
									Pencairan Sudah Diproses
								</h5>
								<p>Pencairan tutup akun ini sudah diproses dan diselesaikan.</p>
							</div>
							<router-link :to="{ name: 'close.account.liquidation' }" class="btn btn-secondary">
								<i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
								Kembali
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { endpoint, host } from "../../host";
import httpService from "../../services/http-service";
import errorService from "../../services/error-service";
import globalService from "../../services/global-service";
import Swal from "sweetalert2";

export default {
	created() {
		this.getDetail();
	},

	data() {
		return {
			data: {},
			liquidationInfo: {
				wallet: {
					amount: 0,
					admin_fee: 0,
					total_amount: 0,
					has_wallet: false
				},
				shares: {
					total_shares: 0,
					total_amount: 0,
					details: []
				},
				grand_total: 0
			},
			form: {
				evidance_of_transfer: null,
				evidance_of_transfer_preview: null,
				description: '',
			},
		};
	},

	computed: {
		walletData() {
			return this.liquidationInfo.wallet;
		},
		shareData() {
			return this.liquidationInfo.shares.details || [];
		},
		totalShareAmount() {
			return this.liquidationInfo.shares.total_amount || 0;
		},
		grandTotal() {
			return this.liquidationInfo.grand_total || 0;
		},
	},

	methods: {
		async getDetail() {
			try {
				const response = await httpService.get(
					endpoint['close.account.account-detail'].replace(':id', this.$route.params.id)
				);
				if (response.data.status) {
					this.data = response.data.data;
					console.log(this.data);
					
					this.liquidationInfo = response.data.liquidation_info || this.liquidationInfo;
				} else {
					errorService.displayError(response.data);
					// this.$router.push({ name: "close.account.liquidation" });
				}
			} catch (error) {
				errorService.displayError(error);
				// this.$router.push({ name: "close.account.liquidation" });
			}
		},

		filesChange(event) {
			const file = event.target.files[0];
			if (file) {
				if (file.size > 2048000) {
					Swal.fire({
						icon: "error",
						title: "File Terlalu Besar",
						text: "Ukuran file maksimal 2MB",
					});
					return;
				}

				this.form.evidance_of_transfer = file;
				this.form.evidance_of_transfer_preview = URL.createObjectURL(file);
			}
		},

		async processLiquidation() {
			if (!this.form.evidance_of_transfer) {
				Swal.fire({
					icon: "error",
					title: "Bukti Transfer Diperlukan",
					text: "Silakan upload bukti transfer terlebih dahulu",
				});
				return;
			}

			const result = await Swal.fire({
				title: "Konfirmasi Pencairan",
				html: `
          <p>Anda akan memproses pencairan tutup akun dengan rincian:</p>
          <table class="table table-sm">
            <tr>
              <td class="text-start"><strong>Investor:</strong></td>
              <td class="text-end">${this.data.name}</td>
            </tr>
            <tr>
              <td class="text-start"><strong>Bank:</strong></td>
              <td class="text-end">${this.data.bank_name} - ${this.data.bank_account_number}</td>
            </tr>
            <tr>
              <td class="text-start"><strong>Total Pencairan:</strong></td>
              <td class="text-end"><strong>${this.formatCurrency(this.grandTotal)}</strong></td>
            </tr>
          </table>
          <p class="text-danger mt-2"><strong>Proses ini tidak dapat dibatalkan!</strong></p>
        `,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ya, Proses!",
				cancelButtonText: "Batal",
			});

			if (result.isConfirmed) {
				try {
					const formData = new FormData();
					formData.append("evidance_of_transfer", this.form.evidance_of_transfer);

					const response = await httpService.post(
						endpoint['close.account.process-liquidation'].replace(':id', this.$route.params.id),
						formData
					);

					if (response.data.status) {
						Swal.fire({
							icon: "success",
							title: "Berhasil!",
							text: "Pencairan tutup akun berhasil diproses",
						}).then(() => {
							this.$router.push({ name: "close.account.liquidation" });
						});
					} else {
						errorService.displayError(response.data);
					}
				} catch (error) {
					errorService.displayError(error);
				}
			}
		},

		formatCurrency(value) {
			// return value;
			return globalService.toIdr(value);
		},

		getKtpImageUrl(filename) {
			// return `${this.$store.state.host}/storage/close_account/ktp/${filename}`;
			return `${host}/storage/uploads/close_account/${filename}`;
		},

		openKtpPreview() {
			if (this.data.ktp_image) {
				window.open(this.getKtpImageUrl(this.data.ktp_image), '_blank');
			}
		},
	},
};
</script>
